import { IRowNode } from 'ag-grid-community';
import FaultActions from 'components/tables/data/fault/FaultActions';
import { FaultRow } from 'components/tables/data/fault/types';

/**
 * Column for the actions.
 */
export default function ActionsColumn({ node, data }: { node: IRowNode<FaultRow>; data: FaultRow }) {
  return (
    <FaultActions
      {...data}
      compactOnTablet
      onResolutionSaved={() => node.setData({ ...data, isFixed: true, isFixedText: 'fixed' })}
      onFaultFixed={({ fixedAt, fixedNote, fixedBy, recordedBy }) =>
        node.setData({
          ...data,
          fixed: {
            fixedAt,
            fixedNote,
            recordedBy: recordedBy ?? fixedBy,
            fixedBy: {
              ...fixedBy,
            },
          },
          isFixed: true,
          isFixedText: 'fixed',
        })
      }
    />
  );
}
